import React from 'react'

export default function Danger({className}) {
    return (
        <svg 
        className={`${className} w-8 h-8 text-[#F82117]`} 
        aria-hidden="true" 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none"
        height="30"
        viewBox="0 0 24 24"
        width="24"
        >
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.8" d="M12 20A16.4 16.4 0 0 1 5 6.7L12 4l7 2.7A16.7 16.7 0 0 1 12 20Z" />
        </svg>
    )
}
